import { AppVersionImport } from './Imports'
const { RoutesMap, UpdateVersion } = AppVersionImport

const AppVersionRoute = () => {
    return [
        {
            path: RoutesMap.UPDATE_VERSION.path,
            element: <UpdateVersion />
        },
    ]
}

export default AppVersionRoute;
